import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENV } from '@app/env';
import { retry, catchError } from 'rxjs/operators';
import { Utilities } from './utilities';

@Injectable()
export class ReportsData {

  constructor(
    private http: HttpClient,
    private utilities: Utilities
  ) { }

  getCouponsReport(clientId: string) {
    return this.http.post<any>(`${ENV.backend}/reports/user/childs/${clientId}`, {
      "Users": {
        "email": "default-10",
        "displayName": 1
      },
      "params": {
        "UserCoupons":
          { "title": "es", "created_at": 1, "redeemed": 1, "redeem_at": 1 }
      }
    }).pipe(
      retry(3),
      catchError(err => [this.utilities.consoleDecorator('Error: ', err, 'orange')])
    )
  }

  getReserveReport(clientId: string) {
    return this.http.post<any>(`${ENV.backend}/reports/user/childs/${clientId}`, {
      "Users": {
        "email": "default-10",
        "displayName": 1
      },
      "join": {
        "entity": "Reserves",
        "field": "reserveId",
        "params": {
          "title": "es"
        }
      },
      "params": {
        "UserReserves": { "created_at": "es", "entity": 1, "reserveId": 1 }
      }
    }
    ).pipe(
      retry(3),
      catchError(err => [this.utilities.consoleDecorator('Error: ', err, 'orange')])
    )

  }

}


// WEBPACK FOOTER //
// ./src/providers/reports.ts